import WidgetsDashboard from './component'

export default WidgetsDashboard
